import React from 'react';
import { FollowsShape, UserShape } from '../../shapes';
import { Link } from 'react-router-dom';
import Waiting from '../waiting';
import DateMaster from '../../stores/utils/date_master';
import PropTypes from 'prop-types';
import FollowDisplayName from '../follow_display_name';

export default class Follows extends React.Component {

  static propTypes = {
    user: UserShape,
    follows: FollowsShape,
    onLoadFollows: PropTypes.func
  }

  componentDidMount() {
    if (this.props.user.get('slug')) {
      this.props.onLoadFollows(this.props.user.get('slug'));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.get('slug') !== this.props.user.get('slug')) {
      this.props.onLoadFollows(this.props.user.get('slug'));
    }
  }

  render() {
    if (this.props.follows.get('loading')) {
      return this.renderLoading();
    } else if (!this.props.user.get('public')) {
      return this.renderNoFollows();
    } else if (this.props.follows.get('error')){
      return this.renderError();
    } else if (this.props.follows.get('follows').size > 0) {
      return this.renderFollows();
    } else {
      return this.renderNoFollows();
    }
  }

  renderNoFollows() {
    return (
      <div className='center'>
        <div>
          <b>Well, you don't follow anybody yet.</b>
        </div>
        <div className='action'>
          <Link to='/account/recommend_people_to_follow' className='menu-cta-small'>Follow People!</Link>
        </div>
      </div>
    );
  }

  renderFollows() {
    const follows = this.props.follows.get('follows').map((follow, i) => {
      return this.renderSingleFollow(follow, i);
    });

    return (
      <div className='follow-rows'>
        <div className='give-me-15-down'>
          <b>Following</b>: { this.props.user.get('followsCount') }
          <span className='dot-spacer'></span>
          <Link to='/account/recommend_people_to_follow' className='menu-cta-small'>find people to follow</Link>
        </div>
        { follows }
      </div>
    );
  }

  renderSingleFollow(follow, index) {
    return (
      <li key={ index } className='list-group-item'>
        <div className='row follow-row'>
          <div className='col-sm-6'>
            <FollowDisplayName user={ follow } />
            <div className='item-meta'>
              { follow.get('headline') }
            </div>
          </div>
          <div className='col-sm-3 item-meta'>Followed on: { DateMaster.format(follow.get('followedAt')) }</div>
          <div className='col-sm-3 item-meta'>Tacks: { follow.get('tacksCount') }</div>
        </div>
      </li>
    );
  }   

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }

  renderError() {
    return (
      <b>Hmm. It looks like something bad happened. Sorry.</b>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/people_board/people_board_follows.jsx